module.exports = __webpack_public_path__ + "img/icon72.9a32443d.png";